import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { Permissions } from "app/shared/helpers/permissions";

@Injectable({
  providedIn: "root",
})
export class AdminService {
  private emitChange$: Subject<any> = new BehaviorSubject<any>(null);
  private AdminRouteConfigSource: Subject<any> = new Subject<any>();
  private ownPermissionsChangeSource: Subject<Permissions> =
    new Subject<Permissions>();
  public ownPermissionsChange$: Observable<any> =
    this.ownPermissionsChangeSource.asObservable();
  public isSearchBarActive: boolean;

  public emit(value: any): void {
    this.emitChange$.next(value);
  }

  set routerConfig(config: any) {
    this.AdminRouteConfigSource.next(config);
  }

  set ownPermissionsChange(value: Permissions) {
    this.ownPermissionsChangeSource.next(value);
  }

  // TODO Refactor and enable lint rule.
  get emitChange(): BehaviorSubject<any> {
    return this.emitChange$ as BehaviorSubject<any>;
  }
}
